module.exports = __webpack_public_path__ + "static/media/divider.b6092f2b.png";